import React from 'react';
import Chart from 'components/Charts';

interface Props {
  data: any;
}

const RiskSummary = ({ data }: Props) => {
  return (
    <div style={{ height: '272px', padding: '0 1rem' }}>
      <Chart.RiskSummaary.RiskSummary data={data} />
    </div>
  );
};

export default RiskSummary;
